import { getList } from './list'
import { getInfo } from './info'
import { getNotification } from './get'
import { markAsRead } from './mark'

export default {
  getList,
  getInfo,
  getNotification,
  markAsRead,
}
